import { render, staticRenderFns } from "./AdminSendEmailModal.vue?vue&type=template&id=68344c36"
import script from "./AdminSendEmailModal.vue?vue&type=script&lang=js"
export * from "./AdminSendEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports